import emailIcon from "@assets/icons/emailIcon.svg";
import DefaultImage from "@assets/Tabla.svg";
import Image from "@elements/ResponsiveImage/Image";
import Heading from "@elements/Typography/Heading";
import { ProcessedAuthorContent } from "@typings/Opensearch";
import { Link } from "react-router";
import { twMerge } from "tailwind-merge";

export type AuthorCardProps = {
  author: ProcessedAuthorContent;
  displayWidth: number;
  displayHeight: number;
  imageWrapper?: string;
  hasEmail?: boolean;
  hrefTitle?: boolean;
  authorCardWrapper?: string;
};

export default function AuthorCard({
  author,
  displayWidth,
  displayHeight,
  imageWrapper,
  authorCardWrapper,
  hasEmail = true,
}: AuthorCardProps) {
  const { email, name } = author;
  return (
    <div
      className={twMerge(
        "flex gap-3 xmd:gap-4 pt-1 xmd:pt-7 pb-10 items-center",
        authorCardWrapper,
      )}
    >
      <div className={twMerge("", imageWrapper)}>
        <Image
          displayWidth={displayWidth}
          srcWidth={displayWidth}
          srcHeight={displayHeight}
          src={author.authorImage?.url ?? DefaultImage}
          alt={name}
          dataTestId="author"
          className="rounded-[50%]"
        />
      </div>
      <div className="flex flex-col">
        <Heading className="text-xl xmd:text-2xl font-bold font-primary pl-1 pt-2 leading-6 xmd:leading-8 text-grey-500">
          {name}
        </Heading>
        {hasEmail && email && (
          <div className="flex gap-2">
            <img
              height={20}
              width={20}
              alt="email-icon"
              src={emailIcon}
              className="inline"
              loading="lazy"
            />
            <Link
              to={`mailto:${email}`}
              className={twMerge(
                "w-full text-sm font-opensans font-bold leading-4 underline text-red-600 hover:text-red-200",
              )}
            >
              <span>{email}</span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
